import React from 'react';
import {useTranslation} from "react-i18next";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';
import scrollToElement from 'scroll-to-element';

const TopBoxing = ({machines}) => {
    const {t} = useTranslation()

    const options = {
        nav: true,
        loop: true,
        dots: false,
        center: false,
        lazyLoad:true,
        navText: [],
        autoWidth:true,
        lazyLoadEager: 3,
        mouseDrag: false,
        animateOut: 'fadeOut',
        responsive: {
            0: {
                items: 1,
            },
            567: {
                items: 2,
            },
            767: {
                items: 3,
            },
            1023: {
                items: 4,
            },
        },
    };

    const events = {
        onInitialized: () => {
            document.querySelector('.top_boxing').querySelectorAll('.owl-item').forEach(item => {
                item.addEventListener('click', (e) => {
                    const section = document.querySelector(`.items[data-page="${e.target.closest('.box').dataset.id.replace(/ /g, '')}"]`);
                    if (section) {
                        scrollToElement(section)
                    }
                })
            })
        }
    }

    const item = {
        items: machines.map(item => <div
            key={item.id}
            className="box"
            data-id={item.name.replace(/ /g,'')}
        >
            {item.prev_image ? <img src={item.prev_image} alt=""/> : null}
            {item.name ? <h1>{item.name}</h1> : null}
            <button>{t('Характеристики')}</button>
        </div>)
    };

    return (
        <OwlCarousel
            options={options}
            events={events}
            touch-action="pan-y"
            className="owl-carousel owl-theme top_boxing"
        >{item.items}
        </OwlCarousel>
    );
};

export default TopBoxing;